import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Lab settings keys
export const LAB_SETTINGS = {
  PARENT_COMPONENT_ITEMS: 'parentComponentItems',
} as const;

// Lab settings state interface
interface LabSettingsState {
  parentComponentItems: boolean;
}

// Load initial state from localStorage
const loadFromLocalStorage = (): LabSettingsState => {
  try {
    const savedSettings = localStorage.getItem('cript-lab-settings');
    if (savedSettings) {
      return JSON.parse(savedSettings);
    }
  } catch (e) {
    console.error('Failed to load lab settings from localStorage:', e);
  }
  // Default: all lab features are OFF
  return {
    parentComponentItems: false,
  };
};

// Save state to localStorage
const saveToLocalStorage = (state: LabSettingsState) => {
  try {
    localStorage.setItem('cript-lab-settings', JSON.stringify(state));
  } catch (e) {
    console.error('Failed to save lab settings to localStorage:', e);
  }
};

const initialState: LabSettingsState = loadFromLocalStorage();

const labSettingsSlice = createSlice({
  name: 'labSettings',
  initialState,
  reducers: {
    toggleParentComponentItems: (state) => {
      state.parentComponentItems = !state.parentComponentItems;
      saveToLocalStorage(state);
    },
    setParentComponentItems: (state, action: PayloadAction<boolean>) => {
      state.parentComponentItems = action.payload;
      saveToLocalStorage(state);
    },
  },
});

export const { toggleParentComponentItems, setParentComponentItems } = labSettingsSlice.actions;
export default labSettingsSlice.reducer;